import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

// TODO: Modificar solo lo agregue por mientras
export const DefaultSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    style: 'width: 100%',
    rows: 0
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;'
      }
    ]
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 300px',
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mt-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;'
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mt-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 50%; height: 200px;'
      }
    ]
  },
];
